module.exports = __webpack_public_path__ + "assets/img/driver-btn-07b08b6c.png";